import * as React from "react";
import { ReactElement } from "react";
import { Link } from "react-router-dom";
import { Button, Header, HeaderContent, HeaderSubheader, Menu, MenuItem } from "@/components/bp/bp-ui";
import { BPDocumentTitle } from "./BPDocumentTitle";
import { innerText } from "./Utils";
import { BPButton } from "@/components/bp/bpbutton";

export interface PageHeaderProps {
    header: string | React.ReactNode[] | React.ReactElement;
    documentTitle?: string;
    renderRight?: () => ReactElement;
    subheader?: string | ReactElement;
    buttons?: Array<{ label: string, to?: string, action?: () => Promise<any>, negative?: boolean, showIf?: boolean }>;
}

export function PageHeader(props: PageHeaderProps) {
    return <>
        <BPDocumentTitle title={props.documentTitle ?? (props.header instanceof Array || React.isValidElement(props.header) ? innerText(props.header) : props.header)} />
        <Menu secondary>
            <MenuItem header>
                <Header size={'large'}>
                    <HeaderContent>{props.header}</HeaderContent>
                    <HeaderSubheader>{props.subheader}</HeaderSubheader>
                </Header>
            </MenuItem>
            {(props.renderRight != null || (props.buttons != null && props.buttons.length > 0)) &&
                <MenuItem position={'right'}>
                    {props.renderRight &&
                        props.renderRight()}
                    {(props.buttons ?? []).filter(m => m.showIf == null || m.showIf).map(m => (
                        <MenuItem fitted key={`${m.label}`}>
                            <BPButton negative={m.negative} key={m.label} as={m.to != null ? Link : Button} to={m.to} onClick={m.action}>{m.label}</BPButton>
                        </MenuItem>
                    ))
                    }
                </MenuItem>
            }
        </Menu>
    </>;
}
